import { no } from 'zod/v4/locales';
import { openModal } from '../../../../store/actions/modal/modal';
import { openDialogRemoveItems } from '../../../../store/actions/modal/removeItems';
import { nodeMenuCopy } from '../../../../store/actions/nodeMenu/copy';
import { nodeMenuCut } from '../../../../store/actions/nodeMenu/cut';
import { markForCategorization } from '../../../../store/actions/nodeMenu/markForCategorization';

export function getItemActions(catalogConfig, { dispatch, nodeItem, tree }) {
  const nodeActions = {};

  if (nodeItem.node.isChildItem) return nodeActions;

  if (nodeItem.node.isInSuggestion) {
    nodeActions.openAlterSuggestionsDialog = () =>
      dispatch(openModal('AlterSuggestionsDialog', { tree, nodeItem }));
    return nodeActions;
  }

  if (nodeItem.node.isUncategorized) {
    const excludedGroups = ['date-group_no-product-name', 'date-group_no-date'];
    if (!excludedGroups.includes(nodeItem.node.parentId)) {
      nodeActions.nodeMenuCut = () =>
        dispatch(markForCategorization(tree, nodeItem));
    }
    return nodeActions;
  }

  if (catalogConfig.item.copy) {
    nodeActions.nodeMenuCopy = () => dispatch(nodeMenuCopy(tree, nodeItem));
  }
  if (catalogConfig.item.cut) {
    nodeActions.nodeMenuCut = () => dispatch(nodeMenuCut(tree, nodeItem));
  }

  if (catalogConfig.item.remove) {
    nodeActions.openDialogRemoveItem = () =>
      dispatch(openDialogRemoveItems(tree, nodeItem));
  }

  return nodeActions;
}
